import Resizer from "react-image-file-resizer"

interface DistanceProps {
    latitudeA: number | null
    longitudeA: number | null
    latitudeB: number | null
    longitudeB: number | null
    distanceTitle: string
}

interface Distance {
    latitudeA: number
    longitudeA: number
    latitudeB: number
    longitudeB: number
}

export const Methods = {
    getDate() {
        return {
            online: Date.now(),
            offline: Date.now() - 60000,
        }
    },
    getNextDate(nextDate: number) {
        const date = new Date(nextDate)
        return {
            date: (
                (
                    date.getDate() < 10
                        ? '0' + date.getDate()
                        : date.getDate()
                ) + '.'
                + (
                    date.getMonth() < 9
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1
                )
                + '.'
                + date.getFullYear()
            ),
            time: (
                (
                    date.getHours() < 10
                        ? '0' + date.getHours()
                        : date.getHours()
                ) + ':' + (
                    date.getMinutes() < 10
                        ? '0' + date.getMinutes()
                        : date.getMinutes()
                )
            ),
        }
    },
    timer(time: number | null) {
        if (time) {
            const seconds = Math.floor(time / 1000)
            const minutes = Math.floor(seconds / 60)
            const hours = Math.floor(minutes / 60)
            const days = Math.floor(hours / 24)
            return {
                day: days,
                hour: hours - (days * 24),
                minute: minutes - (hours * 60)
            }
        } else {
            return {
                day: 0,
                hour: 0,
                minute: 0
            }
        }
    },
    getRandomCode() {
        const min = 100000
        const max = 999999
        return Math.floor(min + Math.random() * (max + 1 - min))
    },
    getRandomPassword() {
        const length = 16
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
        let res = '';
        for (let i = 0, n = charset.length; i < length; ++i) {
            res += charset.charAt(Math.floor(Math.random() * n))
        }
        return res
    },
    priceSecurity(price: number) {
        return parseFloat(price.toString().replace(/,/g, '.')).toFixed(2)
    },
    resizer: (file: any) => new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            800,
            800,
            "jpeg",
            90,
            0,
            (uri: any) => {
                resolve(uri);
            },
            "file",
            800,
            800
        )
    }),
    resizerMini: (file: any) => new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            200,
            200,
            "jpeg",
            90,
            0,
            (uri: any) => {
                resolve(uri);
            },
            "file",
            200,
            200
        )
    }),
    counter(number: number) {
        
        const count = number.toString()

        let len = count.length

        if (len > 3 && len < 5) {
            return '+' + count[0] + (parseInt(count[1]) > 0 ? '.' + count[1] : '') + 'K'
        } else if (len > 4 && len < 6) {
            return '+' + count[0] + count[1] + (parseInt(count[2]) > 0 ? '.' + count[2] : '') + 'K'
        } else if (len > 5 && len < 7) {
            return '+' + count[0] + count[1] + count[2] + (parseInt(count[3]) > 0 ? '.' + count[3] : '') + 'K'
        } else if (len > 6 && len < 8) {
            return '+' + count[0] + (parseInt(count[1]) > 0 ? '.' + count[1] : '') + 'M'
        } else if (len > 7 && len < 9) {
            return '+' + count[0] + count[1] + (parseInt(count[2]) > 0 ? '.' + count[2] : '') + 'M'
        } else if (len > 8 && len < 10) {
            return '+' + count[0] + count[1] + count[2] + (parseInt(count[3]) > 0 ? '.' + count[3] : '') + 'M'
        } else {
            return count
        }
    },
    distance: ({latitudeA, longitudeA, latitudeB, longitudeB, distanceTitle}: DistanceProps) => {
        
        if (latitudeA && longitudeA && latitudeB && longitudeB) {
            
            const getDistance = ({latitudeA, longitudeA, latitudeB, longitudeB}: Distance) => {
                const R = 6371210; // Radius of the earth in km
                const dLatitude = deg2rad(latitudeB-latitudeA)  // deg2rad below
                const dLongitude = deg2rad(longitudeB-longitudeA)
                const a = 
                    Math.sin(dLatitude/2) * Math.sin(dLatitude/2) +
                    Math.cos(deg2rad(latitudeA)) * Math.cos(deg2rad(latitudeB)) * 
                    Math.sin(dLongitude/2) * Math.sin(dLongitude/2)
    
                    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
                    const d = R * c; // Distance in km
                return d;
            }
            
            const deg2rad = (deg: number) => {
                return deg * (Math.PI/180)
            }
    
            const distance = Math.floor(
                getDistance({latitudeA, longitudeA, latitudeB, longitudeB})
            )
    
            const kilometros = distance / 1000
    
            return kilometros < 100 ? kilometros + ' ' + distanceTitle + '.' : null
            
        } else {

            return null

        }
    },
    textCutter: (text: string, limit: number) => {
        if (text) {
            text = text.trim()
            if( text.length <= limit) return text
            text = text.slice(0, limit)
            return text.trim() + "..."
        } else {
            return ''
        }
    },
    getNextPhone(nextPhone: string) {
        const code = nextPhone.split(' ')[0]
        const phone = nextPhone.split(' ')[1]

        const newPhone = code + (
            code === '+993'
                ? (
                    ' (' + phone[0] + phone[1] + ') '
                    + phone[2] + phone[3] + '-'
                    + phone[4] + phone[5] + '-'
                    + phone[6] + phone[7]
                )
                : code === '+7'
                    ? (
                        ' (' + phone[0] + phone[1] + phone[2] +') '
                        + phone[3] + phone[4] + phone[5] + '-'
                        + phone[6] + phone[7] + '-'
                        + phone[8] + phone[9]
                    )
                    : code === '+90'
                        ? (
                            ' (' + phone[0] + phone[1] + phone[2] +') '
                            + phone[3] + phone[4] + phone[5] + '-'
                            + phone[6] + phone[7] + '-'
                            + phone[8] + phone[9]
                        )
                        : (
                            ' ' + phone
                        )
        )
        return newPhone
    }
}